export default () => {
    return useCookie('_lb_id', {
        maxAge: 31536000, // 365 days
        secure: true,
    })
}
